import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useFetchCustomerRelatedBy = (id: string) => {
  return useQuery({
    queryKey: ['customerRelatedBy', id],
    queryFn: () => api.referral.fetchCustomerRelatedBy(id),
    enabled: false, // Запрос выполняется только по требованию
  })
}
